import axios from "axios";
const instance=axios.create({
   /*  baseURL:'http://localhost:5001/clone-32c5d/us-central1/api' */
    // baseURL:'http://localhost:5001/sk-s-shop/us-central1/api'
    baseURL:process.env.NODE_ENV==='development'?'http://localhost:4001':'https://skgrocery-server.vercel.app/'
         
});

export default instance;